import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { BaseDto } from '../../base/dtos/base.dto';

/**
 * Status tracking priority DTO for lists
 */
export class StatusTrackingPriorityListDto extends BaseDto {
	subject!: AppSubjectEnum;
	status!: string;
	priority!: number;
}
